import clsx from 'clsx';
import Skeleton from 'components/Skeleton/Skeleton';
import { ProductCategory } from 'screens/AccessExpressV3/accessExpress.types';
import ServiceTypeTag, {
  ServiceType,
} from 'screens/AccessExpressV3/BaseComponents/SeviceType';

interface AccessServiceTileSkeletonProps {
  category: ProductCategory;
}

const AccessServiceTileSkeleton = ({
  category,
}: AccessServiceTileSkeletonProps) => (
  <div className="flex h-full flex-col">
    <header
      className={clsx(
        'relative flex min-h-[64px] flex-col items-start gap-1 rounded-t-2xl p-3 pb-0',
        'border-b border-background-base-surface-3',
      )}
    >
      <span
        className={clsx(
          'flex flex-row items-center gap-2 font-bold',
          'text-sm',

          'text-content-base-subdued',
        )}
      >
        <Skeleton className="h-[20px] w-[49px]" />
      </span>
      <span className="text-xs font-medium text-content-base-subdued">
        <Skeleton className="h-[16px] w-[75px]" />
      </span>
      <span className="absolute right-3 top-3 opacity-50">
        <ServiceTypeTag
          type={category as ServiceType}
          className="ml-4 max-h-6 w-[85px]"
          labelClassName="whitespace-nowrap"
        />
      </span>
    </header>

    <ul className="flex flex-1 divide-x divide-background-base-surface-3">
      <li className="flex flex-1 flex-col items-start gap-1 p-3 pb-0">
        <span
          className={clsx('text-xs font-bold', 'text-content-base-subdued')}
        >
          <Skeleton className="h-[16px] w-[49px]" />
        </span>
        <span className="text-[10px] font-semibold text-content-base-subdued">
          <Skeleton className="h-[16px] w-[75px]" />
        </span>
      </li>
    </ul>
  </div>
);

export default AccessServiceTileSkeleton;
